import { RootState } from '../../../rootReducer';
import { RedirectParamsState } from './redirectParamsSlice';

export const selectRedirectParamsState = (state: RootState): RedirectParamsState => {
  return state.auth.redirect;
};
